import { useEffect } from 'react';
import { FirebaseFirestore } from '@capacitor-firebase/firestore';
import { logger } from 'features/logger/logger';
import { useAppDispatch } from 'features/store/hooks';
import type { DocumentData } from '@capacitor-firebase/firestore';

// TODO: Error handling
export const useDocumentSnapshotDispatch = <
  T extends DocumentData = DocumentData,
>(
  collectionPath: string,
  action: (data: T | undefined) => { payload: T | undefined; type: string },
  documentId?: string
) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!documentId) {
      return;
    }

    const subscribeToDoc = async (reference: string) => {
      return await FirebaseFirestore.addDocumentSnapshotListener(
        {
          reference,
        },
        event => {
          if (event?.snapshot.data) {
            const data = event.snapshot.data;

            // @ts-expect-error -- TS2345 because I say so, figure out types later
            dispatch(action(data));
          } else {
            dispatch(action(undefined));
          }
        }
      );
    };

    let callbackId: string | undefined = undefined;

    logger.debug(
      `Subscribing to Firebase document (col: ${collectionPath}, doc: ${documentId})`
    );

    void subscribeToDoc(`${collectionPath}/${documentId}`).then(r => {
      callbackId = r;
    });

    return () => {
      if (callbackId) {
        logger.debug(
          `Unsubscribing from Firebase document (col: ${collectionPath}, doc: ${documentId})`
        );
        void FirebaseFirestore.removeSnapshotListener({
          callbackId,
        });
      }
    };
  }, [collectionPath, documentId, action, dispatch]);
};
